import { makeStyles } from '@material-ui/core/styles';

const useReservationStyles = makeStyles(theme => ({
    '@global': {
        '.rounded-field .MuiOutlinedInput-root': {
            borderRadius: 12,
            background: '#fff',
            transition: 'box-shadow .25s, border-color .25s'
        },
        '.rounded-field .MuiOutlinedInput-root fieldset': { borderColor: '#dfe3ea' },
        '.rounded-field .MuiOutlinedInput-root:hover fieldset': { borderColor: '#b8c2cf' },
        '.rounded-field .MuiOutlinedInput-root.Mui-focused': {
            boxShadow: '0 0 0 3px rgba(66,133,244,0.25)'
        },
        '.rounded-field .MuiOutlinedInput-root.Mui-focused fieldset': { borderColor: '#4285f4' },
        '.rounded-field .MuiInputLabel-outlined.Mui-focused': { color: '#1d60d6' },

        // CLÉ: Assurer que le MaterialTable a son propre défilement
        '.scrollable-table .MuiTableContainer-root': {
            flex: 1,
            maxHeight: '100% !important',
            overflowY: 'auto !important' // Défilement vertical sur le conteneur du tableau
        },
        '.scrollable-table .MuiPaper-root': {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            overflow: 'hidden'
        },
        '.scrollable-table .MuiPaper-root > .MuiToolbar-root': {
            flexShrink: 0
        },
        '.scrollable-table .MuiPaper-root > .MuiToolbar-root + div': {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minHeight: 0
        },
        '.scrollable-table .MuiPaper-root > .MuiToolbar-root + div .MuiTableContainer-root': {
            flex: 1,
            display: 'flex',
            flexDirection: 'column'
        }
    },
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        padding: theme.spacing(0.5, 1),
        boxSizing: 'border-box',
        overflow: 'hidden'
    },
    headerBar: {
        display: 'none'
    },
    title: {
        fontWeight: 600,
        fontSize: '1.25rem',
        flexGrow: 1
    },
    content: {
        flex: 1, // Assure que content prend la hauteur restante du root
        display: 'grid',
        gridTemplateColumns: 'minmax(400px,1fr) minmax(400px,1fr) 380px',
        gap: theme.spacing(2),
        alignItems: 'stretch',
        overflow: 'hidden' // Empêche le débordement des colonnes dans la grille
    },
    tablesWrapper: { display: 'contents' },
    tableCard: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0, // CLÉ: Permet au contenu (la table) de prendre la hauteur restante et de défiler
        // allow internal table to expand and use remaining height
        '& > div.MuiCard-root, & > .MuiCard-root': {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minHeight: 0
        }
    },
    sidePanel: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        height: '100%',
        minHeight: 0, // CLÉ: Permet au panneau de ne pas déborder dans le grid
        overflow: 'hidden'
    },
    filtersCard: {
        padding: theme.spacing(2),
        borderRadius: 8,
        background: theme.palette.background.paper,
        boxShadow: '0 2px 4px rgba(0,0,0,0.07)',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1)
    },
    optionWarning: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        color: theme.palette.warning.dark
    },
    optionOk: { display: 'flex', alignItems: 'center', gap: 6 },
    badgeInline: {
        background: 'rgba(255,193,7,0.15)',
        color: '#b28704',
        fontSize: 11,
        padding: '1px 6px',
        borderRadius: 8
    },
    snackbarSuccess: { background: '#1b7f36', color: '#fff' },
    buttonGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1)
    },
    formCard: {
        padding: theme.spacing(2),
        borderRadius: 8,
        background: theme.palette.background.paper,
        boxShadow: '0 2px 4px rgba(0,0,0,0.07)',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1)
    },
    actionsPanel: {
        padding: theme.spacing(0.8, 0.9, 1),
        borderRadius: 16,
        background: 'linear-gradient(135deg,#ffffff 0%, #fafbff 100%)',
        boxShadow: '0 10px 26px -6px rgba(20,30,55,0.18), 0 4px 12px -3px rgba(20,30,55,0.10)',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.75),
        alignItems: 'stretch',
        height: '100%',
        minHeight: 0,
        overflowY: 'auto'
    },
    actionsTitle: {
        fontWeight: 600,
        letterSpacing: '-0.5px',
        fontSize: 20,
        marginBottom: theme.spacing(0.5)
    },
    actionBtn: {
        textTransform: 'none',
        borderRadius: 14,
        padding: theme.spacing(0.6, 1.6),
        fontWeight: 500
    },
    roundedField: {
        '& .MuiOutlinedInput-root': {
            borderRadius: 12,
            background: '#fff',
            '& fieldset': { borderColor: '#dfe3ea' },
            '&:hover fieldset': { borderColor: '#b8c2cf' },
            '&.Mui-focused': {
                boxShadow: '0 0 0 3px rgba(66,133,244,0.25)',
                '& fieldset': { borderColor: '#4285f4' }
            }
        },
        '& .MuiInputLabel-outlined.Mui-focused': { color: '#1d60d6' }
    },
    dividerThin: { margin: theme.spacing(1.5, 0) },
    sectionTitle: {
        fontSize: '.85rem',
        fontWeight: 600,
        opacity: .8,
        textTransform: 'uppercase',
        letterSpacing: '.5px'
    },
    '@global big-checkbox': {},
    bigCheckbox: {},
    filterRow: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        padding: '0 2px'
    },
    checkLabel: {
        margin: 0,
        '& .MuiCheckbox-root': { padding: 4 },
        '& .MuiFormControlLabel-label': {
            fontSize: 12,
            fontWeight: 500,
            color: '#334155',
            lineHeight: 1.2
        }
    }
}));

export default useReservationStyles;